// extracted by mini-css-extract-plugin
module.exports = {"licenceBox":"style_licenceBox__1SVQl","list":"style_list__2hJDI"};